





ENV = require "config/env"
FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	computed:
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		projectName: -> return this.$route.params.projectName
		projectNo: -> return FUNCTIONS.getProjectNo this.projectName
		page: -> return WP.getPageObject(this.projectName.replace("en_",""))
	methods:
		renderText: (title) -> return if !this.isEnglish then title.ja else title.en



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/about/header.vue